<div
  class="xi-modal__container change-dfg__container"
  *transloco="let t; read: 'apply-comparison-dialog-component'"
>
  <h2 class="xi-modal__title kxi-text-center">{{ t('apply-comparison') }}</h2>

  <div class="xi-modal__content change-dfg__content">
    <div class="change-dfg__dropdown">
      <xi-dropdown
        [(ngModel)]="selectedComparisonId"
        label="{{ t('label') }}"
        placeholder="{{ t('placeholder') }}"
        name="comparisons"
        [stretch]="true"
        [data]="comparisonsData"
      ></xi-dropdown>
    </div>
  </div>

  <div class="xi-modal__actions">
    <xi-default-button
      type="button"
      text="{{ t('cancel') }}"
      fill="text"
      (onClick)="onCancel()"
    ></xi-default-button>

    <xi-default-button
      text="{{ t('apply') }}"
      (onClick)="onSave()"
      [disabled]="!selectedComparisonId"
    ></xi-default-button>
  </div>
</div>
